exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.button-div[data-v-4cb8deb5]{text-align:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:100%\n}\n.button-div[data-v-4cb8deb5],.form[data-v-4cb8deb5]{display:-webkit-box;display:-ms-flexbox;display:flex\n}\n.form[data-v-4cb8deb5]{margin:0 auto;-ms-flex-wrap:wrap;flex-wrap:wrap\n}\n.item[data-v-4cb8deb5]{width:29%\n}", ""]);

// exports
